import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Constants } from 'src/app/constants';
import { AetSafetyDashboardService } from 'src/app/services/aet-safety-dashboard.service';
import { AetStateService } from 'src/app/services/aet-state.service';

@Component({
  selector: 'app-final-edit-safety',
  templateUrl: './final-edit-safety.component.html',
  styleUrls: ['./final-edit-safety.component.scss'],
  standalone: false // NOSONAR
})
export class FinalEditSafetyComponent implements OnInit {

  heading: any;
  domicile: any;
  domicileList: any;
  errormsg: any;
  siteItems: any;
  selected_position_id: any;
  yesCheck: any;
  noCheck: any;
  processDropDown;
  tmTitleDropDown;
  lengthOfServiceDropDown;
  process;
  tmTitle;
  lengthOfService;
  swf;
  sop;
  ecg;
  tm;
  lsa;
  prodInvst = [];
  description
  causeOfIncident
  lpinitiatedMsg
  productionImpactDesc: any = '';
  deleteAccessible: boolean = true;
  isAccessible: boolean = true;
  maxi = 1000;
  ldiv: any = 0;
  flag = false
  productionImpact: any;
  select_val = 'SELECT A VALUE'
  constructor(
    public dialogRef: MatDialogRef<FinalEditSafetyComponent>,
    private readonly aetSafetyDashboardService: AetSafetyDashboardService,
    private readonly constants: Constants,
    private readonly aetStateService: AetStateService,
    @Inject(MAT_DIALOG_DATA) public dataStore: any
  ) { }

  ngOnInit(): void {
    // this.checkRoles();

    this.heading = this.dataStore.header;
    this.tmTitleDropDown = this.dataStore.tmTitleDrpDown;
    this.processDropDown = this.dataStore.processDrpDown;
    this.lengthOfServiceDropDown = this.dataStore.losDrpDown;
    this.process = this.processDropDown?.find(
      (x) => x.value == this.dataStore.data.process   // NOSONAR
    )?.value;
    this.processDropDown.sort((a, b) => (a.value < b.value ? -1 : 1));
    this.process = this.process ? this.process : this.select_val;
    this.tmTitle = this.tmTitleDropDown?.find(
      (x) => x.value == this.dataStore.data.tmTitle   // NOSONAR
    )?.value;
    this.tmTitleDropDown.sort((a, b) => (a.value < b.value ? -1 : 1));
    this.tmTitle = this.tmTitle ? this.tmTitle : this.select_val;
    this.lengthOfService = this.lengthOfServiceDropDown?.find(
      (x) => x.value == this.dataStore.data.lengthOfService   // NOSONAR
    )?.value;
    this.lengthOfServiceDropDown.sort((a, b) => (a.label < b.label ? -1 : 1));



    this.lengthOfService = this.lengthOfService ? this.lengthOfService : this.select_val;
    this.swf = this.dataStore.data.swf;
      if (this.dataStore.data.swf == 4) {   // NOSONAR
      this.prodInvst.push('1');
    }
    this.sop = this.dataStore.data.sop;
      if (this.dataStore.data.sop == 4) {   // NOSONAR
      this.prodInvst.push('3');
    }
    this.ecg = this.dataStore.data.ecg;
      if (this.dataStore.data.ecg == 4) {   // NOSONAR
      this.prodInvst.push('5');
    }
    this.tm = this.dataStore.data.tm;
      if (this.dataStore.data.tm == 4) {   // NOSONAR
      this.prodInvst.push('2');
    }
    this.lsa = this.dataStore.data.lsa;
    if (this.dataStore.data.lsa == 4) {   // NOSONAR
      this.prodInvst.push('4');
    }

    this.causeOfIncident = this.dataStore.data.causeOfIncident
    this.description = this.dataStore.data.description
    this.lpinitiatedMsg = this.dataStore.data.lpCounterMeasures

    this.productionImpact = this.dataStore.data.productionImpact;
    if (this.productionImpact == 'YES') {   // NOSONAR
      this.yesCheck = true;
      this.productionImpactDesc = this.dataStore.data.productionImpactDesc;
    }
    else if (this.productionImpact == null) {   // NOSONAR
      this.yesCheck = false;
      this.productionImpact = 'NO';
    }
    else { this.yesCheck = false; }


    this.ldiv = this.productionImpactDesc?.length
  }




  checkChange(value: string) {
    this.ldiv = value.length;
    if (this.ldiv == 0) {   // NOSONAR
      this.flag = true
    } else {
      this.flag = false

    }
  }
  async checkRoles() {
    await this.aetStateService.getRoles();
    const roles = this.aetStateService.getroleState();
    const userRoles = JSON.parse(roles);
    // this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);

    // if (
    //   (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin)) ||
    //   userRoles.includes(this.constants.LIOS_UAC_LP_Filter) ||
    //   userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) ||
    //   userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) ||
    //   userRoles.includes(this.constants.LIOS_UAC_MTM_Planner) ||
    //   userRoles.includes(this.constants.LIOS_UAC_AET_LP) ||
    //   userRoles.includes(this.constants.LIOS_UAC_General_User)
    // ) {

    if (
      (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin)) ||
      userRoles.includes(this.constants.LIOS_UAC_LP_Filter) ||
      userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) ||
      userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) ||
      userRoles.includes(this.constants.LIOS_UAC_MTM_Planner) ||
      userRoles.includes(this.constants.LIOS_UAC_AET_LP)
    ) {

      // if (
      //   (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin)) ||
      //   userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) ||
      //   userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) ||
      //   userRoles.includes(this.constants.LIOS_UAC_MTM_Planner)
      // ) {
      this.deleteAccessible = true;


    }
    // } 
  }
  close(): void {
    this.dialogRef.close({ event: 'CloseEvent' });
  }

  deleteEvent() {
    this.dialogRef.close({ event: 'onDeletePress', id: this.dataStore.data.safetyEventId });
  }






  check: boolean = true;
  changedval(event: any) {
    if (event.target.checked) { this.prodInvst.push(event.target.value); }
    else {
      this.prodInvst = this.prodInvst.filter(
        (item) => item != event.target.value      // NOSONAR
      );                      
    }

    //Validations


    this.check = this.prodInvst.length > 0
  }

  afterSubmit(data: any) {






    if (data.valid && this.check && this.tmTitle != this.select_val && this.process != this.select_val && this.lengthOfService != this.select_val) { // NOSONAR


      if (this.yesCheck) {

        if (this.ldiv > 0) {
          this.saveClick()
        } else {
          this.flag = true
        }
      } else {
        this.saveClick()
      }


    }


  }

  saveClick(): void {


    this.errormsg = '';

    const updateObjectfinal = {
      safetyEventFinalId: this.dataStore.data.safetyEventFinalId,
      safetyEventId: this.dataStore.data.safetyEventId,
      reportId: 746,
      tmTitle: this.tmTitle == this.select_val ? null : this.tmTitle,   // NOSONAR
      process: this.process == this.select_val ? null : this.process,   // NOSONAR
      lengthOfService: this.lengthOfService == this.select_val ? null : this.lengthOfService,   // NOSONAR
      description: this.description,
      causeOfIncident: this.causeOfIncident,
      lpCounterMeasures: this.lpinitiatedMsg,
      productionImpact: this.productionImpact,
      productionImpactDesc: this.productionImpactDesc,
      probInvesCheckPointDesc: null,
      probInvesCheckPointId: this.prodInvst,
      teamMember: null,
      LastUpdatedBy: this.dataStore.data.createdBy,
    };
    // this.ngxUiLoaderService.start(this.constants.LoaderComponent)

    this.aetSafetyDashboardService
      .updateFinalsafetyDashboard(updateObjectfinal)
      ?.subscribe(
        (response) => {
          if (response == 'Success') {   // NOSONAR
            this.dialogRef.close({
              event: 'SaveEvent',
              responseType: 'success'
              // eventType: this.eventType,
            });
          } else {
            // do nothing
          }
        },
        (_error) => {
          // do nothing 
        }
      );


  }

  prodImpact(value: any) {
    if (value == 'YES') {   // NOSONAR
      this.yesCheck = true;
      this.flag = true;
      this.productionImpact = value;
    }
    else {
      this.yesCheck = false;
      this.flag = false;
      this.productionImpact = value;
    }
  }
}
